import { useEffect } from 'react';

const BASE_URL = 'https://bestbuddy.fun';
const DEFAULT_TITLE = 'BESTBUDDY – Dein KI-Wellness-Begleiter mit Nanouk';
const DEFAULT_DESC = 'BESTBUDDY vereint Ernährung, Schlaf, Fitness und Gesundheit in einer kostenlosen App – mit KI-Analyse, Foto-Mahlzeiten-Scan und Husky Nanouk als Coach.';

let staticTagsRemoved = false;
const removeStaticSeoTags = () => {
    if (staticTagsRemoved) return;
    document.querySelectorAll('[data-static-seo]').forEach((el) => el.remove());
    staticTagsRemoved = true;
};

// React 19 native metadata hoisting: title/meta/link rendered here are moved to <head>
// and removed on unmount. JSON-LD scripts stay in body (valid for Google/Bing).
export const Seo = ({ title, description, path = '/', type = 'website', image = '/og-image.jpg', language = 'de', noindex = false, jsonLd = [], withHreflang = false }) => {
    useEffect(() => { removeStaticSeoTags(); }, []);
    const fullTitle = title ? `${title} | BESTBUDDY` : DEFAULT_TITLE;
    const desc = (description || DEFAULT_DESC).slice(0, 160);
    const url = `${BASE_URL}${path}`;
    const dePath = path === '/en' ? '/' : path.startsWith('/en/') ? path.slice(3) : path;
    const enPath = dePath === '/' ? '/en' : `/en${dePath}`;
    const img = image.startsWith('http') ? image : `${BASE_URL}${image}`;
    const schemas = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);

    return (
        <>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            {withHreflang && !noindex && (
                <>
                    <link rel="alternate" hrefLang="de" href={`${BASE_URL}${dePath}`} />
                    <link rel="alternate" hrefLang="en" href={`${BASE_URL}${enPath}`} />
                    <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}${dePath}`} />
                </>
            )}
            <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="BESTBUDDY" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={img} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content={language === 'de' ? 'de_CH' : 'en_US'} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={img} />
            {schemas.map((schema, i) => (
                <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
            ))}
        </>
    );
};
